import { store } from '@/store';

export default function canAccessToAppMiddleware({ next, router, localStore }) {
	let validToken = store.isTokenValid();
	if (validToken === false) {
		router.replace({ redirect: '/pages/login' });
	}
	next();
}
